export default __webpack_public_path__ + "static/media/Commercial.2c88c42c.jpg";